'use client';
import React from 'react';
import { Typography, Button, ButtonProps } from '@mui/material';
import { CallToAction } from '../../types/blocks/carousel';

interface CallToActionButtonProps extends Partial<ButtonProps> {
  button: CallToAction | undefined;
  className?: string;
  textClassName?: string;
  target?: React.HTMLAttributeAnchorTarget | undefined;
}

export const CallToActionButton: React.FC<CallToActionButtonProps> = (props) => {
  const { button, className, textClassName, target, ...buttonProps } = props;

  if (!button) return null;
  switch (button.variant) {
    case 'button_primary':
      return (
        <Button
          href={button.href}
          size="large"
          variant="contained"
          color="primary"
          className={className}
          {...buttonProps}
        >
          <Typography className={textClassName} variant="button-l">
            {button.text}
          </Typography>
        </Button>
      );

    case 'button_secondary':
      return (
        <Button
          href={button.href}
          size="large"
          variant="contained"
          color="inherit"
          className={className || 'mt-4'}
          {...buttonProps}
        >
          <Typography className={textClassName} variant="button-l" color="primary">
            {button.text}
          </Typography>
        </Button>
      );

    case 'image':
      return (
        <a href={button.href} target={target}>
          <img src={button.image?.url} className={className} />
        </a>
      );

    case 'link':
      return (
        <Button
          href={button.href}
          size="large"
          variant="text"
          color="primary"
          className={className || 'mt-4'}
          {...buttonProps}
        >
          <Typography className={textClassName} variant="button-l">
            {button.text}
          </Typography>
        </Button>
      );
  }
};
